import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { pageView } from 'services/tracking/duck';
import { getDisplayName } from 'helpers/component';
import { processWorkOrders } from 'helpers/tracking';

export default function PageViewEnhancer(options = {}) {
    const storeKey = options.store || 'store';
    delete options.store;

    return function PageViewHOC(WrappedComponent) {
        class PageView extends React.Component {
            constructor(props, context) {
                super(props);
                this.store = context[storeKey];
                this.state = {};
            }

            componentDidMount() {
                if (!options.trackEntity) {
                    this.props.pageView({ page: options.page });
                }
            }

            static getDerivedStateFromProps(props, state) {
                const { workOrders } = props;
                if (options.trackEntity && props.entityName !== state.entityName) {
                    const opportunityDetails = processWorkOrders({ workOrders });

                    props.pageView({
                        page: options.page,
                        entity: props.entityName,
                        entityId: props.entityId,
                        brandName: props.brandName,
                        brandId: props.brandId,
                        layer: props.layer,
                        ...opportunityDetails
                    });
                    return {
                        ...state,
                        entityName: props.entityName
                    };
                }
                return null;
            }

            render() {
                // Wraps the input component in a container, without mutating it. Good!
                return <WrappedComponent {...this.props} />;
            }
        }

        const mapStateToProps = state => ({
            brandName: get(state, 'entities.meta.brand.name'),
            brandId: get(state, 'entities.meta.brandId'),
            layer: get(state, 'entities.meta.brandAlias.layer', '3'),
            workOrders: get(state, 'entities.meta.workOrders', []),
            entityName: state.entities.meta.name,
            entityId: state.entities.meta.id,
        });

        PageView.contextTypes = {
            [storeKey]: PropTypes.object
        };

        PageView.displayName = `PageView(${getDisplayName(WrappedComponent)})`;

        return connect(mapStateToProps, { pageView })(PageView);
    };
}



// WEBPACK FOOTER //
// ./src/hoc/PageView.js